import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, empty } from 'rxjs';
import { of } from 'rxjs';
export function configurationServiceInitializerFactory(configurationService: ConfigService): Function {
  // a lambda is required here, otherwise `this` won't work inside ConfigurationService::load
  return () => configurationService.load();
}

@Injectable()
export class ConfigService {
  private loaded = false;
  private configuration: any;
  private configUrl = 'assets/config/ui-config.json';


  constructor(private http: HttpClient) {
  }

  public getConfig(): any {
    return this.configuration;
  }
 /** public getConfigNewss(): Observable<any> {
    let googleAnalytics : any;
    if(localStorage.getItem("ui-config")){
       googleAnalytics = localStorage.getItem("ui-config");
    }else{
    googleAnalytics = this.http.get<any>(this.configUrl);
    }
    return googleAnalytics;
  }  */

  public getConfigNew(): Observable<any> {
    
    let googleAnalytics;
    let data=JSON.parse(localStorage.getItem('ui-config'));
    if (data) {
      return of(data); // Wrap local storage data in an observable
    } else {
      return this.http.get<any>(this.configUrl);
    }
    

    return googleAnalytics;
  }


  // the return value (Promise) of this method is used as an APP_INITIALIZER,
  // so the application's initialization will not complete until the Promise resolves.
  public load(): Promise<any> {
    if (this.loaded) {
      return of(this, this.configuration).toPromise();
    } else {
      const configurationObservable = this.http.get(`assets/config/ui-config.json`); // path is relative to that for app's index.html
      return configurationObservable.pipe(
        catchError(error => {
          // Handle error gracefully
          console.error('Error loading configuration:', error);
          return of(null); // Emit a new Observable with null value
        })
      ).toPromise()
      .then(config => {
        if (config !== null) {
          this.configuration = config;
          this.loaded = true;
        }
        return config;
      });
    }
  }
}
